const thousandSeparator = (num, separator) => (num || 0).toString().replace(/\B(?=(\d{3})+(?!\d))/g, separator);

export default thousandSeparator;
